import { Fragment } from 'react';

import CropViewer from '../cropViewer';

export interface CoverUploaderImageSizeItem {
  /** 最小图片宽度 */
  minWidth?: number;
  /** 最小图片高度 */
  minHeight?: number;
  /** 建议图片宽度 */
  recWidth?: number;
  /** 建议图片高度 */
  recHeight?: number;
  /** 建议图片比例 */
  cropRatio?: number;
  /** 裁剪框宽度 */
  cropContainerWidth: number;
  /** 裁剪框高度 */
  cropContainerHeight: number;
}

function CropBar(props: {
  url: string;
  name: string;
  isHorizontal: boolean;
  corpItem: CoverUploaderImageSizeItem;
  onClose: () => void;
  onConfirm: (cropUrl: string) => void;
}) {
  const { url, name, isHorizontal, corpItem, onClose, onConfirm } = props;

  if (!url) {
    return;
  }

  return (
		<Fragment>
			<CropViewer
				name={name}
        isHorizontal={isHorizontal}
				cropperProps={{ src: url }}
				{...corpItem}
				onCancel={onClose}
				onConfirm={onConfirm}
			/>
		</Fragment>
  );
}

export default CropBar;
